import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
export default {
  ValidateForm(form, message, isCreate = true, is_lite = false) {
    /*if(form.Tag.trim() === ""){
      toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.TAG_EMPTY)
      return false
    }else */
    if (form.Name.trim() === "") {
      toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.NAME_EMPTY)
      return false
    } else if (form.Description.trim() === "") {
      toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.DESCRIPTION_EMPTY)
      return false
    } else if (form.SerialNumber.trim() === "") {
      toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.SERIAL_NUMBER_EMPTY)
      return false
    } else if (form.Status === undefined && !is_lite ) {
      toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.STATUS_EMPTY)
      return false
    } else if (form.Type === undefined && !is_lite ) {
      toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.TYPE_EMPTY)
      return false
    }
    if (isCreate) {
      if (form.Site === undefined || form.Site.trim() === '') {
        toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.SITE_EMPTY)
        return false
      } else if (form.Location === undefined || form.Location.trim() === '') {
        toast.warning(message.ERROR.MODEL.ASSET.FORM.VALIDATION.LOCATION_EMPTY)
        return false
      }
    }
    return true
  },
  InitOptionValue: function (self) {
    if (self.state.PurchaseCurrency === '' && self.props.CurrencyReducer.rs !== null && self.props.CurrencyReducer.rs.length > 0) {
      let selectedIndex = 0;
      for (let i = 0; i < self.props.CurrencyReducer.rs.length; i++) {
        if (self.props.CurrencyReducer.rs[i].IsDefault) {
          selectedIndex = i;
          break;
        }
      }
      self.setState({ PurchaseCurrency: self.props.CurrencyReducer.rs[selectedIndex].Alias })
    }
    if (self.state.Type === '' && self.props.AssetTypeReducer.rs !== null && self.props.AssetTypeReducer.rs.length > 0) {
      self.setState({ Type: self.props.AssetTypeReducer.rs[0].Alias })
    }
    if (self.state.Status === '' && self.props.AssetStatusReducer.rs !== null && self.props.AssetStatusReducer.rs.length > 0) {
      self.setState({ Status: self.props.AssetStatusReducer.rs[0].Alias })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/form.js